import tw, { styled } from 'twin.macro';

const TableCell = styled.td`
  ${tw`text-left font-normal text-sm px-4 py-3`}
`;

export default TableCell;
